﻿
export interface IPolicyHolderUserSearchCriteria {
    submissionIds: Array<string>;
    policyHolderUserRelationshipTypeCodeId: string;
   
}


export class PolicyHolderUserSearchCriteria {
    submissionIds: Array<string>;
    policyHolderUserRelationshipTypeCodeId: string;

}